import { CommunityEnum } from '@/app/types';

/**
 * 将类型映射为 CommunityEnum
 * @param type 类型字符串
 * @returns 对应的 CommunityEnum 值
 */
export const mapTypeToExploreTab = (type?: string) => {
  if (type === 'short_film' || type === 'single' || type === 'series') {
    return CommunityEnum.ShortFilm;
  }
  if (type === 'tutorial') {
    return CommunityEnum.Tutorial;
  }
  if (type === 'image_asset') {
    return CommunityEnum.ImageAsset;
  }
  return CommunityEnum.MediaAsset;
};
